'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCuratorBaseUrl = exports.getSailthruCustomerId = exports.getSoastaMPulseApiKey = exports.getSegmentWriteKey = exports.getPubNubSubscribeKey = exports.getPubNubPublishKey = exports.getGoogleApiKey = exports.getDeployment = exports.getClassicBaseUrl = exports.getBuildNumber = exports.getBaseUrl = undefined;
exports.default = reducer;

var _reselect = require('reselect');

/* reducer */
var DEFAULT_STATE = {};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.config;
};

var getBaseUrl = exports.getBaseUrl = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.baseUrl || '';
});

var getBuildNumber = exports.getBuildNumber = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.buildNumber || '';
});

var getClassicBaseUrl = exports.getClassicBaseUrl = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.classicBaseUrl || '';
});

var getDeployment = exports.getDeployment = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.deployment || '';
});

var getGoogleApiKey = exports.getGoogleApiKey = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.googleApiKey || '';
});

var getPubNubPublishKey = exports.getPubNubPublishKey = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.pubNubPublishKey || '';
});

var getPubNubSubscribeKey = exports.getPubNubSubscribeKey = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.pubNubSubscribeKey || '';
});

var getSegmentWriteKey = exports.getSegmentWriteKey = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.segmentWriteKey || '';
});

var getSoastaMPulseApiKey = exports.getSoastaMPulseApiKey = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.soastaMPulseApiKey || '';
});

var getSailthruCustomerId = exports.getSailthruCustomerId = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.sailthruCustomerId || '';
});

var getCuratorBaseUrl = exports.getCuratorBaseUrl = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.curatorImgUrl || '';
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/config.js
// module id = iS9E
// module chunks = 46